"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateHtml = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var generateHtml = function generateHtml(string, word) {
  var regex = new RegExp("(".concat(word, ")"), 'gi');
  return string.replace(regex, "<span class=\"".concat(_style["default"].highlighted, "\">$1</span>"));
};
exports.generateHtml = generateHtml;
var _default = function _default(_ref) {
  var string = _ref.string,
    word = _ref.word;
  if (!word || typeof string !== 'string' || !string.toUpperCase().includes(word.toUpperCase())) {
    return string;
  }
  var html = generateHtml(string, word);
  return /*#__PURE__*/_react["default"].createElement("span", {
    dangerouslySetInnerHTML: {
      __html: html
    }
  });
};
exports["default"] = _default;